module.exports = __webpack_public_path__ + "static/img/product/teacher_default.png";